<h1 mat-dialog-title>Delete answer</h1>
<div mat-dialog-content>
  <p>Are you sure you want delete this test?</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">No Thanks</button>
  <!-- <button class="btn" (click)="deleteAnswer()" cdkFocusInitial>Ok</button> -->
</div>
